import React from 'react';
import { Box, Spinner } from '@zillow/constellation-10';

export default function IdvSpinner() {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: '100%',
        overflowY: 'auto',
      }}
    >
      <Spinner size="lg" />
    </Box>
  );
}
